import { FC } from "react";

export const HistoryIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="24"
      height="27"
      viewBox="0 0 24 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""}`}
    >
      <g clipPath="url(#clip0_3893_90901)">
        <path
          d="M12 24.668C8.93333 24.668 6.26111 23.6513 3.98333 21.618C1.70556 19.5846 0.4 17.0457 0.0666667 14.0013H2.8C3.11111 16.3124 4.13889 18.2235 5.88333 19.7346C7.62778 21.2457 9.66667 22.0013 12 22.0013C14.6 22.0013 16.8056 21.0957 18.6167 19.2846C20.4278 17.4735 21.3333 15.268 21.3333 12.668C21.3333 10.068 20.4278 7.86241 18.6167 6.0513C16.8056 4.24019 14.6 3.33464 12 3.33464C10.4667 3.33464 9.03333 3.69019 7.7 4.4013C6.36667 5.11241 5.24444 6.09019 4.33333 7.33464H8V10.0013H0V2.0013H2.66667V5.13464C3.8 3.71241 5.18333 2.61241 6.81667 1.83464C8.45 1.05686 10.1778 0.667969 12 0.667969C13.6667 0.667969 15.2278 0.984635 16.6833 1.61797C18.1389 2.2513 19.4056 3.10686 20.4833 4.18464C21.5611 5.26241 22.4167 6.52908 23.05 7.98464C23.6833 9.44019 24 11.0013 24 12.668C24 14.3346 23.6833 15.8957 23.05 17.3513C22.4167 18.8069 21.5611 20.0735 20.4833 21.1513C19.4056 22.2291 18.1389 23.0846 16.6833 23.718C15.2278 24.3513 13.6667 24.668 12 24.668ZM15.7333 18.268L10.6667 13.2013V6.0013H13.3333V12.1346L17.6 16.4013L15.7333 18.268Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3893_90901">
          <rect
            width="24"
            height="26"
            fill="white"
            transform="translate(0 0.667969)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
